// extracted by mini-css-extract-plugin
module.exports = {"filterPanel":"filtersLayout_filterPanel__1j2OI"};